import React, { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';

/**
 * File System 기반 라우터
 * 수정 금지
 */

const PRESERVED = import.meta.glob('/src/pages/(_app|404).(js|jsx|ts|tsx)', { eager: true });
const ROUTES = import.meta.glob('/src/pages/**/[a-z[]*.(js|jsx|ts|tsx)', { eager: true });

const preserve = Object.keys(PRESERVED).reduce((p, file) => {
  const key = file.replace(/\/src\/pages\/|\.(js|jsx|ts|tsx)$/g, '');
  return { ...p, [key]: (PRESERVED[file] as { default: React.ComponentType }).default };
}, {});

const routes = Object.keys(ROUTES).map((route) => {
  const path = route.replace(/\/src\/pages|index|\.(js|jsx|ts|tsx)$/g, '')
                    .replace(/\[\.{3}[^/]+\]/, '*')
                    .replace(/\[([^/]+)\]/g, ':$1');

  return { path, component: (ROUTES[route] as { default: React.ComponentType }).default };
});

export default function FileRoutes() {
  // eslint-disable-next-line no-underscore-dangle
  const App = preserve?.['_app'] || Fragment;
  const NotFound = preserve?.['404'] || Fragment;

  return (
    <App>
      <Routes>
        {routes.map(({ path, component: Component = Fragment }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route path={'*'} element={<NotFound />} />
      </Routes>
    </App>
  );
}
